import { trackCTAClick } from '../analytics';

export default function FinalCTA() {
  return (
    <section className="final-cta" id="contact">
      <div style={{
        fontFamily: "'Barlow', sans-serif",
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '0.25em',
        color: '#CC1F1A',
        marginBottom: '48px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
      }}>
        07 — LET'S BUILD
        <span style={{ display: 'block', width: '40px', height: '1px', background: '#CC1F1A' }} />
      </div>

      <h2 className="final-cta__head">
        HAVE SOMETHING<br />WORTH BUILDING?
      </h2>

      <a
        href="mailto:hello@veremeen.com"
        className="btn-border btn-border--light"
        onClick={() => trackCTAClick('BUILD TOGETHER', 'final_cta')}
      >
        BUILD TOGETHER →
      </a>

      <div style={{
        marginTop: '48px',
        fontFamily: "'Barlow', sans-serif",
        fontSize: '12px',
        color: 'rgba(255,255,255,0.3)',
        letterSpacing: '0.05em',
      }}>
        hello@veremeen.com
      </div>
    </section>
  );
}
